import * as angular from 'angular';
import { DataViewTypes } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';
import { DataViewFacade } from '@mode/switch-views/contract';
import { map } from 'rxjs/operators';

export const ID = 'emptyReportState';

class EmptyReportStateController implements angular.IOnInit {
  static $inject = ['DataViewFacade'];

  // Currently, this only represents queries, the template below makes that assumption.
  private successfulDatasets$: Observable<DataViewTypes.EnhancedDatasetResult[]>;
  private hasSuccessfulItems$: Observable<boolean>;

  constructor(private dataViewFacade: DataViewFacade) {}

  $onInit(): void {
    this.successfulDatasets$ = this.dataViewFacade.successfulEnhancedDatasets$;
    this.hasSuccessfulItems$ = this.successfulDatasets$.pipe(map((datasetResults) => datasetResults.length > 0));
  }
}

export const emptyReportState: angular.IComponentOptions = {
  template: `
  <div>
    <div class="empty-report-msg">
    <capra-icon icon="illo-empty-report"></capra-icon>
      <h1>This Report doesn't have any charts to view</h1>
      <p class="empty-report-copy" ng-show="ctrl.hasSuccessfulItems$ | async:this">This usually happens when there are no charts in the Report Builder.<br/> Don't worry, you can still view the Report's data:</p>
      <ul class="empty-report-query-list">
        <li ng-repeat="datasetResult in (ctrl.successfulDatasets$ | async:this)"  class="report-view-empty-state-query">
        <a ui-sref="reportShow.noRuns.detailsView.detailsDataset({queryId: datasetResult.queryToken})">{{ datasetResult.displayName }}</a>
        </li>
      </ul>
    </div>
  </div>
  `,
  controller: EmptyReportStateController,
  controllerAs: 'ctrl',
};
